module.exports = __webpack_public_path__ + "static/media/promo8.aea3e6a9.jpg";